var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9599 0.544442C12.9113 0.246745 12.653 0.0195312 12.3416 0.0195312C11.9955 0.0195312 11.715 0.300042 11.715 0.64607V1.6903H6.28502V0.64607L6.27682 0.544442C6.22826 0.246745 5.96991 0.0195312 5.65848 0.0195312C5.31246 0.0195312 5.03194 0.300042 5.03194 0.64607V1.6903H3.57C2.07055 1.6903 0.855001 2.90585 0.855001 4.4053V7.32917V15.2653C0.855001 16.7648 2.07055 17.9803 3.57 17.9803H14.43C15.9295 17.9803 17.145 16.7648 17.145 15.2653V7.32917V4.4053C17.145 2.90585 15.9295 1.6903 14.43 1.6903H12.9681V0.64607L12.9599 0.544442ZM15.8919 6.70263V4.40541C15.8919 3.59801 15.2374 2.94349 14.43 2.94349H12.9681V3.98761C12.9681 4.33364 12.6876 4.61415 12.3416 4.61415C12.0301 4.61415 11.7718 4.38693 11.7232 4.08924L11.715 3.98761V2.94349H6.28502V3.98761C6.28502 4.33364 6.00451 4.61415 5.65848 4.61415C5.34706 4.61415 5.0887 4.38693 5.04014 4.08924L5.03194 3.98761V2.94349H3.57001C2.76261 2.94349 2.10809 3.59801 2.10809 4.40541V6.70263H15.8919ZM2.10809 7.95571H15.8919V15.2654C15.8919 16.0728 15.2374 16.7273 14.43 16.7273H3.57001C2.76261 16.7273 2.10809 16.0728 2.10809 15.2654V7.95571Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateCalendar);
export default __webpack_public_path__ + "static/media/date-calendar.0de13e0bea5b4ddfe64db4b320f5503b.svg";
export { ForwardRef as ReactComponent };